import React from 'react';

import styles from './SettingsBlock.module.css';

type Props = {
  children: React.ReactNode;
};

export const SettingsBlockWrapper: React.FC<Props> = ({ children }) => (
  <div className={styles.SettingsBlock__Wrapper}>{children}</div>
);
